import {createRoot} from "react-dom/client";
import React, {StrictMode} from "react";
import ContragentList from "../components/contragents/ContragentList";
import LastOrder from "../components/personal-dashboard/LastOrder";

const personalDashboard = document.getElementById('js-personal-dashboard');
if (personalDashboard) {

    const widget = createRoot(personalDashboard)

    document.addEventListener("DOMContentLoaded", function () {

        widget.render(
            <StrictMode>
                <LastOrder/>
                <ContragentList/>
            </StrictMode>
        )
    });
}